import { gql, useLazyQuery } from "@apollo/client";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Subtraction } from "../../../CommonFunction/CalculationsWithDecimalValues";
import useProcessData from "../../../CommonFunction/ProcessData";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

const queryfunction = (fields, Refetch) => {
  const query = gql`
  query AccountsOpeningBalanceReport($fromCached: Boolean=${!Refetch}) {
     AccountsOpeningBalanceReport(fromCached: $fromCached) {
      _id
      ${fields?.join(" ")}
    }
  }`;
  return query;
};

const TrailOpeningBalances = () => {
  const Key = "TrailOpeningBalances";
  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [SumObj, setSumObj] = useState({ Closing_In_Cr: 0, Closing_In_Dr: 0 });
  const colAddition = ["Closing_In_Cr", "Closing_In_Dr"];
  let refresh = useSelector((store) => store?.FormFieldData?.refresh);

  const config = useMemo(
    () => ({
      dataKey: "AccountsOpeningBalanceReport",
      dateKeys: [],
      deleteKeys: ["__typename"],
      AddKeys: ["Closing_In_Cr", "Closing_In_Dr"],
    }),
    []
  );

  const [fetchOpeningTrailBalance, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([], refresh), {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  const { loading, TableHeaders } = useFetchTableData(queryfunction, fetchOpeningTrailBalance, setIsLoading, Key);
  useProcessData(data, setFormData, config, error, [], false, setSumObj);

  return (
    <div>
      <HeaderDiv
        title="Opening Balance Report"
        TableKey={Key}
        IsDateSearchShow={false}
        Children={
          <div
            className={`headerChild`}
          >
            Difference :
            {` ${Math.abs(Subtraction(SumObj?.Closing_In_Dr, SumObj?.Closing_In_Cr))} ${SumObj?.Closing_In_Dr > SumObj?.Closing_In_Cr ? "Dr" : "Cr"
              }`}
          </div>
        }
      />
      {isLoading ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {(queryLoading || loading) && <div className="loader-line-div" />}
          <LoadTable
            title={Key}
            data={formData}
            loading={isLoading}
            error={error}
            TableHeaders={TableHeaders}
            colAddition={colAddition}
          />
        </>
      )}
    </div>
  );
};

export default TrailOpeningBalances;
